export const getFileNameAndExtensionFromURL = (url: URL) => {
  try {
    const urlObject = new URL(url)
    const path = urlObject.pathname
    const fileName = path.substring(path.lastIndexOf('/') + 1)

    if (!fileName) {
      return `${Date.now()}`
    }

    const parts = fileName.split('.')

    if (parts.length === 1) {
      return `${Date.now()}`
    }

    const extension = parts.pop()
    const baseName = parts.join('.')

    return baseName + '.' + extension
  } catch (error) {
    console.error('Ошибка при разборе URL:', error)

    return `${Date.now()}`
  }
}
